const CompareStorage = (() => {
  const STORAGE_KEY = 'compare_products';
  const MAX_ITEMS = 4;

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function add(product) {
    const items = getAll();
    if (items.find(p => p.id === product.id)) return false;
    if (items.length >= MAX_ITEMS) return false;
    items.push(product);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    return true;
  }

  function remove(productId) {
    const items = getAll().filter(p => p.id !== productId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function has(productId) {
    return getAll().some(p => p.id === productId);
  }

  function count() {
    return getAll().length;
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY);
  }

  return { getAll, add, remove, has, count, clear };
})();
